import React, { Component } from 'react';
import {connect} from 'react-redux';
import Util from '../../../util';
import {hashHistory} from 'react-router';
import  NavigatorMain from '../../NavigatorMain';
import {getPayAll,getOpenHqt} from '../../../getPay';
import { getTradeInfo } from '../../../action/productAction';


class HqtSuccess extends Component{
	constructor(props){
	    super(props);
		this.state = {
		}
		this.goCallback=false
	}
	funRight() {
		const {  router, callback, fundCode, productType } = this.props.location.state;
		// navigator.popToRoute(router)
		this.goCallback=true;
		hashHistory.go(-4);
	    setTimeout(() => {
	        this.props.dispatch(getTradeInfo(fundCode,'T522',productType,(result,i,type)=>{
	          Object.assign(result,{currentType:type},{currentIndex:i})
	          this.props.dispatch({
	            type:"SUPER_FUND_PAY_INFO",
	            text:result
	          });
	        }))
	    });
	}
	RechargeHqt(){
	  hashHistory.go(-4);
	  setTimeout(() => {
	  	  let { bankAccountShowNo } = this.props.location.state;
	      let data={
	        fundCode:'003003',
	        businessType:'T022',
	        productType:'G',
	        bankAccountShowNo:bankAccountShowNo,
	        refresh: true,
	        _fundCode:this.props.location.state.fundCode
	      }
	      getPayAll( window.history.length, data, hashHistory, 'RechargeHqt')
	  })
  	}
  	componentWillUnmount(){
	    if (this.goCallback) {
	      this.props.location.state.callback ? this.props.location.state.callback() : null
	    }
	}
    render(){
	  	let { openHqt, isShow } = this.props.location.state;
	    return (
	      <div>
	        <NavigatorMain>
	          <div className="header black">
	            <div onClick={()=>hashHistory.goBack()}><span className="headerLeftBtn"></span></div>
	            <div>{ openHqt ? "开通活期通" : "添加银行卡" }</div>
	            <div onClick = {()=>{ this.funRight() }} style={{marginRight:13}}>
	              完成
	            </div>
	          </div>
	        </NavigatorMain>
	        <div className="boxContent">
				<div style={{paddingLeft: 13, paddingRight: 13, backgroundColor: "#fff", paddingBottom: 20, paddingTop: 40}}>
					<div style={{display:"-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", paddingBottom: 10}}>
						<img
						src = {require('../../../img/successO.png')}
						style={{width: 62, height: 62}}
						/>
					</div>
					{
						openHqt ? 
						<div style={{WebkitAlignItems: "center", marginBottom: 10, textAlign: "center"}}>
							<p  style={{color: "#5b6370", fontSize: 13,marginBottom:10}}>华夏基金直销账户开通成功</p>
							<p  style={{color: "#5b6370", fontSize: 13}}>活期通开通成功</p>
						</div> : 
						<div style={{WebkitAlignItems: "center", marginBottom: 10, textAlign: "center"}}>
							<p  style={{color: "#5b6370", fontSize: 13}}>活期通开通成功</p>
						</div>
					}
				</div>
				<div style={{marginTop:30}}>
					{
						isShow ? null :
						<div 
						  style = {styles.touchHighlightBtn} 
						  delayPressIn = {0}
						  onClick = {()=>{ this.RechargeHqt() }}>
						    <div style = {styles.loginView}>
						      <span  style = {{color: '#fff', fontSize: 15, }}>立即充值</span>
						    </div>
						</div>
					}
				  <div style = {Object.assign(styles.touchHighlightBtn, {marginTop: 7})} onClick = {()=>{ this.funRight() }} >
				    <div style = {styles.inversedLoginView}>
				      <span  style = {{color: '#FE492E', fontSize: 15, }}>返回</span>
				    </div>
				  </div>
				</div>
			</div>
	        <div className='addCard-tipBox'>
	          <p style={{marginTop:15}}>温馨提示 :</p>
	          <p>1、活期通是由华夏基金提供的理财产品，华夏财富将为您在华夏基金开立直销账户，并提供活期通充值业务；</p>
	          <p>2、如需变更活期通对应的银行卡，您需分别登录华夏基金官网和华夏财富官网进行银行卡变更，您也可以致电客服热线400-817-5666咨询办理。</p>
	        </div>
	      </div>
	    )
	}
}
const styles = {
  touchHighlightBtn: {
	  marginTop: 14,
	  marginLeft: 13,
	  marginRight: 13,
	  borderRadius: 20,
  },
  loginView: {
		display: "-webkit-flex",
	  backgroundColor: '#FE492E',
	  height: 40,
	  borderRadius: 20,
	  WebkitFlexDirection: 'row',
	  WebkitAlignItems: 'center',
	  WebkitJustifyContent: 'center',
  },
  inversedLoginView: {
		display: "-webkit-flex",
	  backgroundColor: '#ffffff',
	  borderColor: '#fe492e',
	  borderStyle: "solid",
	  height: 40,
	  borderWidth: 1,
	  borderRadius: 20,
	  WebkitFlexDirection: 'row',
	  WebkitAlignItems: 'center',
	  WebkitJustifyContent: 'center',
	} 
}

function mapStateToProps(state,ownProps) {
  return {

  }
}

export default connect(mapStateToProps)(HqtSuccess);



// WEBPACK FOOTER //
// ./src/components/myAssets/myCard/HqtSuccess.js